import { Calendar, ChevronDown, ChevronLeft, Clock } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { InIcon, OutIcon } from "./icons";
import { getPerizinanDetail } from "../../core/service/api_perizinan";

const DetailPerizinanMobile = (props: any) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const toggleArrow = (key: string) => {
    setOpenArrow((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };
  const [openArrow, setOpenArrow] = useState<string[]>([]);
  const [isInOpen, setIsInOpen] = useState(false);
  const [isOutOpen, setIsOutOpen] = useState(false);
  const [detail, setDetail] = useState<any>(null);

  const fetchDetail = async () => {
    try {
      const res = await getPerizinanDetail(id);
      setDetail(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, []);

  return (
    <div className="h-screen flex flex-col py-4 bg-psp-primary font-montserrat">
      <div className="flex-none mb-2">
        <div className="flex d-flex w-full mb-3 px-4">
          <button>
            <ChevronLeft
              className="bg-white w-8 h-8 rounded-lg border p-1"
              onClick={() => navigate(`/perizinan`)}
            />
          </button>
          <div className="absolute left-1/2 -translate-x-1/2 font-bold text-md">
            Detail Pengajuan
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto scrollbar-hide">
        <section className="px-4">
          <div className="flex-1 overflow-y-auto scrollbar-hide">
            <div className="flex flex-col">
              <button onClick={() => toggleArrow("pengajuan")}>
                <div className="flex flex-row justify-between">
                  <p style={{ fontSize: 14 }} className="font-semibold">
                    Informasi Pengajuan
                  </p>
                  <ChevronDown
                    className={`transition-transform ${
                      openArrow.includes("pengajuan") ? "rotate-180" : ""
                    }`}
                  />
                </div>
              </button>
              {openArrow.includes("pengajuan") && (
                <div className="mt-2 text-xs pl-3">
                  <div className="flex flex-col mb-2">
                    <p className="m-0 font-semibold mb-1">Tipe Perizinan</p>
                    <p className="m-0 pl-2">{detail?.boardingLeaveTypeName}</p>
                  </div>
                  <hr className="w-full" />
                  <div className="flex flex-col mb-2">
                    <p className="m-0 font-semibold mb-1">Tanggal Awal Izin</p>
                    <div className="flex items-center">
                      <div className="flex items-center gap-2">
                        <Calendar />
                      </div>
                      <p className="m-0 pl-2">{detail?.startDate}</p>
                    </div>
                  </div>
                  <hr className="w-full" />
                  <div className="flex flex-col mb-2">
                    <p className="m-0 font-semibold mb-1">Tanggal Akhir Izin</p>
                    <div className="flex items-center">
                      <div className="flex items-center gap-2">
                        <Calendar />
                      </div>
                      <p className="m-0 pl-2">{detail?.endDate}</p>
                    </div>
                  </div>
                  <hr className="w-full" />
                  <div className="flex flex-col mb-2">
                    <p className="m-0 font-semibold mb-1">Alasan</p>
                    <p className="m-0 break-words pl-2">{detail?.reason}</p>
                  </div>
                  <hr className="w-full" />
                  <div className="flex flex-col mb-2">
                    <p className="m-0 font-semibold mb-1">
                      Guru Penanggung Jawab
                    </p>
                    <p className="m-0 pl-2">{detail?.teacherName}</p>
                  </div>
                  <hr className="w-full" />
                  <div className="flex flex-col mb-4">
                    <p className="m-0 font-semibold mb-1">Bukti Pendukung</p>
                    <div className="pl-2">
                      <img
                        src={detail.evidenceUrl || "-"}
                        alt="tanpa bukti"
                        className="max-w-40 rounded-lg"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
        <hr className="w-full mt-0" />
        <section className="px-4">
          <div className="">
            <div className="">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <OutIcon className="bg-[#E5F1FF] p-2 rounded-3xl" />
                  <p style={{ fontSize: 14 }} className=" font-semibold m-0">
                    Informasi Absensi Keluar
                  </p>
                </div>
                <button
                  onClick={() => setIsOutOpen(true)}
                  className="bg-[#E5F1FF] text-[#0054E6] rounded-3xl p-2 text-xs w-18"
                >
                  Detail
                </button>
              </div>
            </div>
          </div>
        </section>
        <hr className="w-full" />
        <section className="px-4">
          <div className="">
            <div className="">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <InIcon className="bg-[#B4FADA] p-2 rounded-3xl" />
                  <p style={{ fontSize: 14 }} className=" font-semibold m-0">
                    Informasi Absensi Kembali
                  </p>
                </div>
                <button
                  onClick={() => setIsInOpen(true)}
                  className="bg-[#E5F1FF] text-[#0054E6] rounded-3xl p-2 text-xs w-18"
                >
                  Detail
                </button>
              </div>
            </div>
          </div>
        </section>
        <section className="">
          {isInOpen && (
            <div className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 transition-opacity"></div>
          )}
          {isInOpen && (
            <div className="fixed inset-0 z-50 flex items-end justify-center">
              <div className="absolute inset-0 bg-black/40"></div>
              <div className="relative w-full bg-white rounded-t-3xl py-4 px-3 animate-slideUp">
                <div className="px-2">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                      <InIcon className="bg-[#B4FADA] p-2 rounded-3xl" />
                      <p className="font-semibold m-0 text-lg">
                        Informasi Absensi Kembali
                      </p>
                    </div>
                  </div>
                  <div className="mb-4 text-sm pl-3">
                    <div className="flex flex-col mb-2">
                      <p className="mb-1 font-semibold">Foto Absensi Kembali</p>
                      <img
                        src={detail?.tapBackPhotoUrl || "-"}
                        alt="tanpa bukti"
                        className="max-w-40 rounded-lg"
                      />
                      <hr className="w-full" />
                    </div>
                    <div>
                      <p className="font-semibold mb-2">
                        Tanggal Absensi Keluar
                      </p>
                      <div className="flex items-center">
                        <div className="flex items-center gap-2">
                          <Calendar />
                        </div>
                        <p className="m-0 pl-2">{detail?.tapBackDate || "-"}</p>
                      </div>
                      <hr className="w-full" />
                    </div>
                    <div>
                      <p className="font-semibold mb-2">Jam Absensi Keluar</p>
                      <div className="flex items-center">
                        <div className="flex items-center gap-2">
                          <Clock />
                        </div>
                        <p className="m-0 pl-2">{detail?.tapBackTime || "-"}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  className="bg-[#FF0000] rounded-full w-full h-full p-2 text-white text-sm"
                  onClick={() => {
                    setIsInOpen(false);
                  }}
                >
                  Tutup
                </button>
              </div>
            </div>
          )}
        </section>
        <section className="">
          {isOutOpen && (
            <div className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 transition-opacity"></div>
          )}
          {isOutOpen && (
            <div className="fixed inset-0 z-50 flex items-end justify-center">
              <div className="absolute inset-0 bg-black/40"></div>
              <div className="relative w-full bg-white rounded-t-3xl py-4 px-3 animate-slideUp">
                <div className="px-2">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                      <OutIcon className="bg-[#E5F1FF] p-2 rounded-3xl" />
                      <p className="font-semibold m-0 text-lg">
                        Informasi Absensi Keluar
                      </p>
                    </div>
                  </div>
                  <div className="mb-4 text-sm pl-3">
                    <div className="flex flex-col mb-2">
                      <p className="mb-1 font-semibold">Foto Absensi Keluar</p>
                      <img
                        src={detail?.tapOutPhotoUrl || "-"}
                        alt="tanpa bukti"
                        className="max-w-40 rounded-lg"
                      />
                      <hr className="w-full" />
                    </div>
                    <div>
                      <p className="font-semibold mb-2">
                        Tanggal Absensi Keluar
                      </p>
                      <div className="flex items-center">
                        <div className="flex items-center gap-2">
                          <Calendar />
                        </div>
                        <p className="m-0 pl-2">{detail?.tapOutDate || "-"}</p>
                      </div>
                      <hr className="w-full" />
                    </div>
                    <div>
                      <p className="font-semibold mb-2">Jam Absensi Keluar</p>
                      <div className="flex items-center">
                        <div className="flex items-center gap-2">
                          <Clock />
                        </div>
                        <p className="m-0 pl-2">{detail?.tapOutTime || "-"}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  className="bg-[#FF0000] rounded-full w-full h-full p-2 text-white text-sm"
                  onClick={() => {
                    setIsOutOpen(false);
                  }}
                >
                  Tutup
                </button>
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default DetailPerizinanMobile;
